import api from '../index'

export default {
  // 后端获取路由数据
  routeList: () => api.get('system/menu/menu/menu_data'),

  //   routeList: () => api.get('app/route/list', {
  //   baseURL: '/mock/',
  // }),

  captchaGet: (data: any) => api.post('auth/captcha', data),
  captchaCheck: (data: any) => api.post('auth/verify_captcha', data),

  // 登录
  login: (data: {
    user_code: string
    password: string
    captcha: string
    captcha_token: string
  }) => api.post('auth/login', data),

  // 基于文件系统路由模式下，后端获取导航菜单数据
  menuList: () => api.get('app/menu/list', {
    baseURL: '/mock/',
  }),

  // 获取全局配置
  getGconfig: () => api.get('app/get_gconfig', {
    baseURL: '/mock/',
  }),

}
